import { render } from "./rooming_list.vue?vue&type=template&id=7f0c6311"
import script from "./rooming_list.vue?vue&type=script&lang=js"
export * from "./rooming_list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__